module.exports = __webpack_public_path__ + "static/media/embrassed-energy.58fa9df0.svg";